module.exports = __webpack_public_path__ + "img/20171113190956_81746.4b5a58f0.jpg";